import { observer } from 'mobx-react';
import { FC, useMemo } from 'react';
import marketplaceStore from '../../../store/marketplaceStore';
import { TMarketplaceFeature } from '../../../types/marketplace';
import { branchStore } from '~/mobx/branchStore';
import { getTranslate } from '~/utils/helpers';
import { TOOLTIP_DURATION, TOOLTIP_POSITION, TOOLTIP_TYPE } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import LazyBranchesPicker from '~/view/components/Controls/Pickers/LazyBranchesPicker/LazyBranchesPicker';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';
import Text, { TEXT } from '~/view/components/Text/Text';
import './style.scss';

type TRamadanAddonSettings = Omit<TMarketplaceFeature, 'donationBranchId'> & {
  donationBranchId: number;
};

const RamadanCampaign: FC = observer((): JSX.Element | null => {
  const feature = marketplaceStore.selectedFeature;

  const handleBranchSelect = (options: IPickerOption[]) => {
    const option = options?.[0];
    if (option) marketplaceStore.changeSelectedFeatureData({ donationBranchId: option.value, status: feature?.status });
  };

  if (!isRamadanAddonSettings(feature)) {
    return null;
  }

  const selectedBranchOption = useMemo(() => {
    const branch = branchStore.branches.find((branch) => branch.id === feature.donationBranchId);
    return branch ? [{ label: getTranslate(branch.name), value: branch.id }] : undefined;
  }, [feature.donationBranchId]);

  return (
    <div className="d-flex align-items-center mt-5 ramadan-campaign">
      <Text
        type={TEXT.CUSTOM}
        text="branch"
        className="family-medium text-size-18 required"
        wrapperClassName="flex-1"
        tooltip={{
          message: 'donation_branch_infotip',
          position: TOOLTIP_POSITION.FIXED,
          duration: TOOLTIP_DURATION.EXTRA_LARGE,
          type: TOOLTIP_TYPE.INFO,
        }}
      />
      <LazyBranchesPicker selectedOptions={selectedBranchOption} noReset onSelect={handleBranchSelect} />
    </div>
  );
});

const isRamadanAddonSettings = (feature: TMarketplaceFeature | null): feature is TRamadanAddonSettings => {
  return (feature as TRamadanAddonSettings).donationBranchId !== undefined;
};

export default RamadanCampaign;
